<template>
	<small
		v-if="errorMessage"
		class="d-block text-danger"
		v-html="errorMessage"
	></small>
</template>

<script>
export default {
	methods: {
		closeErrorMessage() {
			this.$store.commit('setGlobalErrorMessage', '');
		},
		closeSuccessMessage() {
			this.$store.commit('setGlobalSuccessMessage', '');
		},
	},
	computed: {
		errorMessage() {
			return this.$store.getters.getGlobalErrorMessage
				? this.$store.getters.getGlobalErrorMessage
				: false;
		},
		successMessage() {
			return this.$store.getters.getGlobalSuccessMessage
				? this.$store.getters.getGlobalSuccessMessage
				: false;
		},
	},
	updated() {
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
	},
	mounted() {
		window.scroll({
			top: 0,
			left: 0,
			behavior: 'smooth',
		});
	},
};
</script>
